'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _colors = require('HubStyleTokens/colors');

var _UITooltip = require('UIComponents/tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _getFeatureDescriptionKey = require('self-service-api/core/utilities/getFeatureDescriptionKey');

var _getFeatureDescriptionKey2 = _interopRequireDefault(_getFeatureDescriptionKey);

var _Hubs = require('self-service-api/constants/Hubs');

var Hubs = _interopRequireWildcard(_Hubs);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeatureName = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteCatalogTableCell__FeatureName'
})(['padding:10px 20px;display:inline-block;& > p{margin-left:8px;margin-bottom:0;font-weight:500;display:inline-block;}text-align:left;:first-child{min-width:55%;text-align:left;}']);

var FeatureDetail = _styledComponents2.default.div.withConfig({
  displayName: 'GrowthSuiteCatalogTableCell__FeatureDetail'
})(['display:inline-block;padding:10px 20px;color:', ';text-align:left !important;p{margin:0;}'], _colors.SLINKY);

var removeParenthesis = function removeParenthesis(limitString) {
  return limitString.replace('(', '').replace(')', '');
};

var GrowthSuiteCatalogTableCell = function GrowthSuiteCatalogTableCell(_ref) {
  var merchandiseId = _ref.merchandiseId,
      featureId = _ref.featureId,
      hub = _ref.hub;

  var cellContent = null;
  var feature = _ImmutableMerchandiseIdMap2.default[merchandiseId].features[featureId];

  if (feature && feature.limit) {
    cellContent = _react2.default.createElement(
      _Small2.default,
      null,
      removeParenthesis(_I18n2.default.text('pricing-pages.limits.' + feature.limit))
    );
  }

  return _react2.default.createElement(
    'td',
    { style: { width: '50%' } },
    _react2.default.createElement(
      FeatureName,
      null,
      featureId && _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_UIIcon2.default, { name: 'success', style: { display: 'inline-block' } }),
        _react2.default.createElement(
          'p',
          { style: { cursor: 'help' } },
          _react2.default.createElement(
            _UITooltip2.default,
            {
              placement: 'right',
              title: _react2.default.createElement(_FormattedMessage2.default, {
                message: (0, _getFeatureDescriptionKey2.default)(featureId, hub)
              })
            },
            _react2.default.createElement(_FormattedMessage2.default, {
              message: 'pricing-pages.features.' + featureId + '.name'
            })
          )
        )
      )
    ),
    _react2.default.createElement(
      FeatureDetail,
      null,
      cellContent
    )
  );
};

GrowthSuiteCatalogTableCell.propTypes = {
  featureId: _react.PropTypes.string,
  merchandiseId: _react.PropTypes.number.isRequired,
  hub: _react.PropTypes.oneOf(Object.keys(Hubs).map(function (hubKey) {
    return Hubs[hubKey];
  })).isRequired
};

exports.default = GrowthSuiteCatalogTableCell;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-catalog/GrowthSuiteCatalogTableCell.js
// module id = 779
// module chunks = 3 4